omadapp.controllers.scenes.animaticaScene = function($page, sceneController) {
    var t = this;
    t.$page = $page
    var app = omadapp.App
    var datos
    var $app = app.getContext()
    var $b = $("body")
    t.onPreCurrent = onPreCurrent 
    t.onCurrent = onCurrent 
    t.onExit = onExit
    t.setData = setData
    t.pausar = pausar
    t.reanudar = reanudar

    t.heredar = omadapp.controllers.scenes.common_methods.heredar
    t.heredar()

    t.clases = {}
    t.sceneController = sceneController
    t.inicializar = inicializar
    omadapp.singletons.implementador.implementar(t, omadapp.interfaces.pausable)
    var saliendo = false
    var salido = false
    function inicializar() {

    }

    function pausar() {
        if (t.selfPausado) return
        t.super.pausar.call(t)
        trace("animaticaScene::pausar()")
        for (var i = 0; t.animaticas && i < t.animaticas.length; i++) {
            t.animaticas[i].pausar()
        }
    }

    function reanudar() {
        if (!t.selfPausado) return
        t.super.reanudar.call(t)
        trace("animaticaScene::reanudar()")
        for (var i = 0; t.animaticas && i < t.animaticas.length; i++) {
            t.animaticas[i].reanudar()
        }

    }

    function terminarSkip() {
        trace ("animaticaScene::terminarSkip")
        trace (t)
         $page.find(".btn_skip").off("click")
        saliendo = true
        if (t.animaticas) {

           /* for (var i = 0; i < t.animaticas.length; i++) {
                t.animaticas[i].pausar()
            }*/
            for (var i = 0; i < t.animaticas.length; i++) {
                t.animaticas[i].finAnimatica(true)
            }
        }
        if (!datos.salida) return
            trace (datos.salida)

            if (datos.salida.salidaSkip) {
                        trace ("salida FS")
                var fs = datos.salida.salidaSkip
                if (fs.exitGame) {
                    if (!salido) {
                        salido = true
                        if (fs.silentMode) {
                            t.sceneController.exitGame(fs.transicion)
                        } else {
                            omadapp.singletons.tachan.mostrar(function() {
                                t.sceneController.exitGame(fs.transicion)
                            })
                        }
                    }

                    return
                } else {

                    t.sceneController.navegar(fs.escena, fs.transicion)
                }
            } else {
                var fi = datos.salida.finIteraciones
                if (fi.exitGame) {
                    if (!salido) {
                        salido = true
                        if (fi.silentMode) {
                            t.sceneController.exitGame(fi.transicion)
                        } else {
                            omadapp.singletons.tachan.mostrar(function() {
                                t.sceneController.exitGame(fi.transicion)
                            })
                        }
                    }

                    return
                } else if (fi) {
                        trace ("salida FI")
                    trace(fi)
                    t.sceneController.navegar(fi.escena, fi.transicion)
                } else {
                    trace(datos)
                    console.warn("la escena no tiene definida una salida")
                }
            }
            


    }

    function terminar() {
        //  $("body").off("generadorAnimaticas.fin",terminar)
        $page.find(".btn_skip").off("click")
        trace("animaticaScene::terminar")
        //if (saliendo) return
        setTimeout(function() {
            trace(datos.salida)
            if (datos.salida) {
                var fi = datos.salida.finIteraciones
                if (fi.exitGame) {
                    if (!salido) {

                        $page.find(".btn_skip").off("click")
                        salido = true;

                        if (fi.silentMode) {
                            t.sceneController.exitGame(fi.transicion)
                        } else {
                            omadapp.singletons.tachan.mostrar(function() {
                                t.sceneController.exitGame(fi.transicion)
                            })
                        }
                    }

                    return
                } else if (fi) {
                    trace(fi)
                    t.sceneController.navegar(fi.escena, fi.transicion)
                } else {
                    trace(datos)
                    console.warn("la escena no tiene definida una salida")
                }
            }
        }, 500)
    }

    function onPreCurrent() {
        omadapp.singletons.factory.prepararEscena (t.datos,t.$page)
        t.super.onPreCurrent.call(t)
    }
    function onCurrent() {
        trace("animaticaScene::onCurrent")
        $page.find(".btn_skip").off("click").click(terminarSkip)
        trace(t.clases)
        trace(t.datos)
      //  t.iniciarPersistencia()
        trace(t.sceneController.persistence)
        t.updateClasses("onCurrent")


        t.insertAnimatics(datos.animatica, terminar)

    } 
    function onExit() {
        t.super.onExit.call(t)
    }

    function setData(json) {
        trace("animaticaScene::setData")
        datos = json
        t.datos = datos
        if (!datos.salida) {
            console.error("no se encuentra datos.salida")
            trace(datos)
        }
    }

}
omadapp.controllers.scenes.animaticaScene.prototype.completeEvent = "escena.fin_animaciones"